import colors from './colors'

export default {
  greenLight: `0px 0px 16px ${colors.greenShadow}`,
  grey: `0px 1px 10px ${colors.grey5}`,
  greyLight: `0px 1px 10px ${colors.grey5Light}`,
  navbar: `0 2px 14px rgba(60, 65, 66, .18)`,
}
